module.exports = __webpack_public_path__ + "img/UC8Logo.3768a344.svg";